module.exports = __webpack_public_path__ + "img/FS2500.1b340d74.png";